/*
 * Example of using grid selection callbacks \ functions
 */

rs.module("development/codedemosgridselection", [],

    function () {

        function initialize(grid, nameColumn, jsSelectors) {

            var selectedValues = $.js(jsSelectors.selectedValues);
            var selectedNames = $.js(jsSelectors.selectedNames);

            // Listen for changes
            grid.selectionChanged(function (values, rows) {
                selectedValues.text(values);
                selectedNames.text((rows.length > 0 ? " = " : "") + rows.map(function (row) { return row[nameColumn]; }));
            });

            // Our buttons for setting selection via script
            $.js(jsSelectors.selectionClear).on("click", function () { grid.selectedValues = null; });
            $.js(jsSelectors.selectionSetSingle).on("click", function () { grid.selectedValues = 1; });
            $.js(jsSelectors.selectionSetMultiple).on("click", function () { grid.selectedValues = [1, 3, 6]; });
            $.js(jsSelectors.selectionFirstRow).on("click", function () { grid.selectFirstRow(); });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);